<div class="error fill heather-700-bg surface-secondary nordic-blue-900-text text-icon-primary rounded mr-large-b">
  <div class="error-container flex ps-small">
    <div class="icon ps-small-r">
      <fcom-icon [name]="SvgLibraryIcon.INFO" class="flex icon-large white-text text-icon-reversed" />
    </div>
    <span class="error-item flex-1">
      <span class="bold-type font-body-1 white-text text-icon-reversed font-body-medium-bold">{{ errorText }}</span>
    </span>
  </div>
</div>
